module.exports = __webpack_public_path__ + "static/hero-desktop-bd72749b467017659103e6be638d38b2.jpg";